import PropTypes from 'prop-types';
import React from 'react';

var TableRowGroup = function TableRowGroup(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

TableRowGroup.propTypes = {
  children: PropTypes.node
};
TableRowGroup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableRowGroup",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};
export default TableRowGroup;